import { Skeleton, Stack, styled } from '@mui/material';
import type { Institution } from '@/models/catalog/course';

const Image = styled('img')(() => ({
  height: 70,
  width: 180,
}));

interface InstitutionLogoProps {
  institution: Institution;
  isLoading: boolean;
}

export const InstitutionLogo = ({
  institution,
  isLoading,
}: InstitutionLogoProps) => {
  if (isLoading) {
    return <Skeleton variant="rectangular" width="100%" height={80} />;
  }

  return (
    <Stack
      height={80}
      alignItems="center"
      justifyContent="center"
      sx={({ shape }) => ({
        backgroundColor: institution.logo_background_color,
        borderTopRightRadius: `${shape.borderRadius}px`,
        borderTopLeftRadius: `${shape.borderRadius}px`,
      })}
    >
      {institution.logo_url && <Image src={institution.logo_url} />}
    </Stack>
  );
};
